import { Box, Heading, Spinner } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { fetchTokenDataFun } from "./action"
import { PatientJoin } from "../PatientJoin/PatientJoin"

export const LandingPage: React.FC = () => {
    const navigate = useNavigate()
    const { token } = useParams()
    const [error, setError] = useState(false)
    const [useNewFlow, setUseNewFlow] = useState<boolean | null>(null)

    useEffect(() => {
        (async () => {
            sessionStorage.setItem('roomToken', token ? token : "")
            let decryptedData = await fetchTokenDataFun()
            if (decryptedData) {
                // If a consultationId exists in the token, it belongs to the new Pococare flow.
                if (decryptedData.consultationId) {
                    setUseNewFlow(true)
                    return
                }

                // Old flow (no consultationId) — route directly to the open ACS room
                if (decryptedData.role === "patient") {
                    sessionStorage.setItem("name", "patient")
                }
                sessionStorage.setItem("roomId", decryptedData.roomId)
                sessionStorage.setItem("beneficiaryId", decryptedData.beneficiaryId)
                sessionStorage.setItem("medicalInfoUrl", decryptedData.medicalInfoUrl)
                sessionStorage.setItem("uploadPrescriptionUrl", decryptedData.uploadPrescriptionUrl)
                
                if (decryptedData.serviceName === "100ms") {
                    navigate(`/100ms/preview/${decryptedData.roomId}/host`)
                } else if (decryptedData.serviceName === "azure") {
                    navigate(`/azure/${decryptedData.roomId}`)
                }
            } else {
                sessionStorage.removeItem("name")
                sessionStorage.removeItem("roomId")
                sessionStorage.removeItem("beneficiaryId")
                sessionStorage.removeItem("medicalInfoUrl")
                sessionStorage.removeItem("uploadPrescriptionUrl")
                setError(true)
            }
        })();
        // eslint-disable-next-line
    }, [])

    if (error) {
        return (
            <Box>
                <Heading textAlign={"center"}>
                    Welcome to Doctor Consult
                </Heading>
                <Heading size={"md"} textAlign={"center"} mt={"200px"}>
                    Oops! Something went wrong. Please try again later.
                </Heading>
            </Box>
        )
    }

    if (useNewFlow === true) {
        return <PatientJoin />
    }

    return (
        <Box display="flex" alignItems="center" justifyContent="center" height="100vh" flexDirection="column" gap="1rem">
            <Spinner size="xl" color="teal" />
            <Heading size="sm" color="gray.500">
                Connecting...
            </Heading>
        </Box>
    )
}